import { NgModule } from "@angular/core";
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SearchComponent} from './search-form/search.component';
import { RecaptchaModule } from 'ng-recaptcha'
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';
import {ToplineComponent} from './top-line/topline.component';


@NgModule({
  imports: [ BrowserModule, FormsModule, ReactiveFormsModule, RecaptchaModule.forRoot(),  RecaptchaFormsModule],
  declarations: [SearchComponent, ToplineComponent ],
  exports: [SearchComponent, ToplineComponent]
})
export class AuditModule { }



// WEBPACK FOOTER //
// C:/Проекты/grant_results/src/app/search/search.module.ts